export class ActionUserRequest{
    public LocationID:number = -1;
    public AuditID:number = -1;
    public EventID:number = -1;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
